import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { ProfileWrapper } from '../ProfileMenu/ProfileMenu.styles';
import { ButtonLink } from '@blueprint/ui';

const BottomMenuWrapper = styled(ProfileWrapper)(
    (props) => css`
        margin-top: 1.75rem;
        border-top: 1px solid ${props.theme.colors['graphic-divider']};
        padding-top: 1.25rem;

        ${props.theme.mediaQueries.large} {
            display: none;
        }

        [data-is-logged-in] & {
            display: none;
        }

        ${ButtonLink} {
            line-height: 20px;
            padding: 14px 24px;
            text-align: left;
            border-radius: ${props.theme.borderRadius['4px']};
            display: flex;
            justify-content: start;
            align-items: center;

            &:focus,
            &:hover {
                text-decoration: none;
                transform: translateY(0);
            }

            :focus {
                box-shadow: inset ${props.theme.focusRing};
            }

            ${props.theme.mediaQueries.large} {
                padding: 14px ${props.theme.spacing['16px']};

                &:focus,
                &:hover {
                    &:after {
                        opacity: 1;
                        height: 2px;
                    }
                }
            }

            &:after {
                content: '';
                position: absolute;
                height: 1px;
                background-color: ${props.theme.colors['primary-brand']};
                opacity: 0;
                left: ${props.theme.spacing['16px']};
                bottom: ${props.theme.spacing['16px']};
                right: ${props.theme.spacing['16px']};
                margin-bottom: -3px;
                margin-left: ${props.theme.spacing['24px']};
            }
        }
    `
);

export { BottomMenuWrapper };
